var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMaxRange = function SvgMaxRange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1E242F",
    d: "M22.398 17.347 17.3 5.681A1.11 1.11 0 0 0 16.291 5h-3.559l.09.844a.292.292 0 0 1-.29.323h-1.063a.292.292 0 0 1-.29-.323L11.267 5H7.71c-.435 0-.83.266-1.011.68L1.602 17.348C1.265 18.12 1.803 19 2.614 19H9.79l.376-3.561a.583.583 0 0 1 .58-.522h2.508c.299 0 .549.225.58.522l.376 3.56h7.177c.81 0 1.348-.88 1.01-1.652M10.994 7.594a.29.29 0 0 1 .29-.26h1.432c.15 0 .275.112.29.26l.168 1.59a.437.437 0 0 1-.434.483H11.26a.437.437 0 0 1-.434-.484zm2.014 6.156h-2.016a.583.583 0 0 1-.58-.645l.185-1.75a.583.583 0 0 1 .58-.522h1.646c.298 0 .549.226.58.522l.185 1.75a.583.583 0 0 1-.58.645"
  })));
};
export default SvgMaxRange;